import { PrebidService } from 'app/services/prebid.service';
import { SapiService } from './../../../services/sapi.service';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
	selector: 'adunit-details-prebid',
	templateUrl: './adunit-details-prebid.component.html',
	styleUrls: ['./adunit-details-prebid.component.scss']
})

export class AdunitDetailsPrebidComponent implements OnInit, OnChanges {
	@Input() adunit: any;
	@Input() form: any;
	publicationPrebidParams: any;
	hasAvailableSystems: boolean; // NB default undefined avoids flashing info message!

	constructor(
		private sapiService: SapiService,
		private prebidService: PrebidService
	) {
	}

	ngOnInit() {
		if (this.adunit && !this.adunit.prebidParams) {
			this.adunit.prebidParams = {};
		} else if (this.adunit && Array.isArray(this.adunit.prebidParams)) {
			this.adunit.prebidParams =
				(this.adunit.prebidParams.length > 0 && typeof this.adunit.prebidParams[0] === 'object')
					? this.adunit.prebidParams[0]
					: {};
		}

		if (this.prebidService.publicationPrebidParams) {
			this.handlePublicationPrebidParams(this.prebidService.publicationPrebidParams);
		} else {
			this.sapiService.getUrl('/publication/prebidParams').subscribe({
				next: (publicationPrebidParams: any) => {
					this.handlePublicationPrebidParams(publicationPrebidParams);
				},
				error: (err) => {
					if (err.status === 404) {
						this.publicationPrebidParams = null;
					}
				},
			});
		}
	}

	handlePublicationPrebidParams(publicationPrebidParams) {
		this.publicationPrebidParams = publicationPrebidParams;
		// check for enabled systems
		this.hasAvailableSystems = (Object.keys(this.publicationPrebidParams)
			.filter((key) => this.publicationPrebidParams[key] && this.publicationPrebidParams[key].enabled).length > 0);
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.adunit && !changes.adunit.firstChange) {
			if (this.adunit && !this.adunit.prebidParams) {
				this.adunit.prebidParams = {};
			} else if (this.adunit && Array.isArray(this.adunit.prebidParams)) {
				this.adunit.prebidParams = (this.adunit.prebidParams.length > 0 && typeof this.adunit.prebidParams[0] === 'object')
					? this.adunit.prebidParams[0]
					: {};
			}
		}
	}

	prebidParamsChanged() {
		this.formDirty();
	}

	formDirty() {
		if (this.form && this.form.form && this.form.form.markAsDirty) {
			this.form.form.markAsDirty();
		}
	}
}
